import axios from 'axios';

export const getOtherBrand = ({ url, token, brand }) =>
  axios({
    method: 'GET',
    url,
    headers: {
      authorization: `Bearer ${token}`,
      'x-g-brand': brand,
    },
  });

export const postOtherBrand = ({ url, username, password }) =>
  axios({
    method: 'POST',
    url,
    data: {
      username,
      password,
    },
  });
